export const getRegionalDatabases = state => {
  return state.regional_databases.data;
};

export const isFetchingRegionalDatabases = state => {
  return state["regional_databases"]["network_activity"].includes("get_regional_databases");
};
